import {Box, Stack, type SxProps, Typography} from "@mui/material"
import {type ComponentType, type FC} from "react"
import {useTranslation} from "react-i18next"
import {RefreshButton} from "../../atoms"

type Props = {
  message: string
  messageStyle: SxProps
  containerStyle?: React.CSSProperties
  buttonContainerStyle?: SxProps
  messageElement?: ComponentType<any>
  hideRefreshButton?: boolean
  refetch: () => void
}

const ErrorMessage: FC<Props> = (props) => {
  const {
    containerStyle,
    buttonContainerStyle,
    message,
    messageElement,
    messageStyle,
    hideRefreshButton,
    refetch,
  } = props
  const {t} = useTranslation()

  const boxStyle = containerStyle || {
    padding: "20px",
    position: "absolute",
    width: "100%",
    zIndex: 2,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  }

  const MessageElement = messageElement

  return (
    <Stack style={boxStyle}>
      <Box marginBottom={"8px"}>
        {!MessageElement ? (
          <Typography sx={messageStyle}>{t(message)}</Typography>
        ) : (
          <MessageElement />
        )}
      </Box>
      <Box sx={buttonContainerStyle || {}}>
        {!hideRefreshButton && <RefreshButton refetch={refetch} />}
      </Box>
    </Stack>
  )
}

export default ErrorMessage
